import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CardGoalsProps } from "./CardGoals.types";
import { CardGoalsContainer } from "./CardGoalsContainer";
import { useAchievementsQuery } from "../../queries";
import { TitleTypography } from "../../styles/CommonWidgetStyles/Typography";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";

export function CardGoals({ enabled = true, achievements }: { enabled?: boolean } & Partial<CardGoalsProps> = {}) {
  const { t } = useTranslation();

  const {
    data: userAchievements
  } = useAchievementsQuery({ enabled: enabled && !achievements });

  const displayAchievements = achievements || userAchievements;

  if(!displayAchievements || displayAchievements.length === 0) return null;

  return (
    <CommonWidgetContainer component="section" aria-label={ t("your_goals_widget_label") } hasSidePadding={ false }>
      <Stack
        role={ "region" }
        aria-label={ t("your_goals_title") }
        alignItems={ "center" }
        justifyContent={ "space-between" }
        direction={ "row" }
        gap={ 1 }
      >
        <TitleTypography tabIndex={ 0 }>{ t("your_goals_title") }</TitleTypography>
      </Stack>
      <CardGoalsContainer achievements={ displayAchievements } />
    </CommonWidgetContainer>
  );
}


